import { BadgeDomain } from "_components/Abstractions/BadgeDomain";
import { Card } from "react-bootstrap";
import { CONTRACTOR_TYPES } from "../../../../domain/ContractorType";
import { Link } from "react-router-dom";

export function IntermediaryListDetails({ contractorTypes, intermediaries }) {
  if (contractorTypes?.includes(CONTRACTOR_TYPES.INTERMEDIARY) && intermediaries?.length === 0) {
    return;
  }

  return (
    <>
      <Card>
        <Card.Header as="h4">Pośrednicy</Card.Header>
        <Card.Body className="upper">
          {(intermediaries == null || intermediaries?.length === 0) && (
            <>Brak pośredników</>
          )}
          {intermediaries?.map((intermediary) => (
            <BadgeDomain
              key={intermediary.intermediaryId}
              bg="success"
              size="small">
              <Link className="clear-link" to={`/contractors/${intermediary.intermediaryId}`}>
                {intermediary.name} {intermediary.isDefault ? " (domyślny)" : ""}
              </Link>
            </BadgeDomain>
          ))}
        </Card.Body>
      </Card>
    </>
  );
}

